import firstPinPrice from './assets/first-pin-price.png';
import secondPinPrice from './assets/second-pin-price.png';
import thirdPinPrice from './assets/third-pin-price.png';
import promoFirstPinPrice from './assets/promo-first-pin-price.png';
import promoSecondPinPrice from './assets/promo-second-pin-price.png';
import promoThirdPinPrice from './assets/promo-third-pin-price.png';
import { IPinPosition } from 'shared/types/pin';

export const PIN_POSITIONS: IPinPosition[] = [
  {
    desktop: { left: '228px', top: '70px' },
    phone: { left: '120px', top: '40px' },
    priceImage: firstPinPrice,
    promoPriceImage: promoFirstPinPrice,
  },
  {
    desktop: { left: '265px', top: '200px' },
    phone: { left: '138px', top: '107px' },
    priceImage: secondPinPrice,
    promoPriceImage: promoSecondPinPrice,
  },
  {
    desktop: { left: '243px', top: '310px' },
    phone: { left: '125px', top: '170px' },
    priceImage: thirdPinPrice,
    promoPriceImage: promoThirdPinPrice,
  },
];
